import { ArrowLongRightIcon } from '@heroicons/react/24/outline'
import { cx } from 'classix'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Section from '@components/common/layout/Section'

import plantsCover from '@src/assets/images/plants-cover.png'
import { submitHubspotForm } from '@src/services/hubspot'

export default function NewsletterSection() {
  const { t } = useTranslation('revamp')

  const [input, setInput] = useState('')
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const [isInvalid, setIsInvalid] = useState(false)

  function isValidEmail(email: string) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    setInput(event.target.value)
    if (isInvalid) {
      setIsInvalid(false)
    }
  }

  async function handleSubmit(event: React.FormEvent | React.MouseEvent) {
    event.preventDefault()

    if (!isValidEmail(input)) {
      setIsInvalid(true)
      return
    }

    try {
      await submitHubspotForm({
        portalId: '22409460',
        formId: 'a6e28f20-82d4-43da-94d2-31f3c0b94a73',
        fields: [
          {
            name: 'email',
            value: input,
          },
        ],
        context: {
          pageUri: window.location.href,
          pageName: document.title,
        },
      })
      setHasSubmitted(true)
    } catch (err) {
      // eslint-disable-next-line
      console.error('Error submitting form:', err)
    }
  }

  return (
    <div className='flex bg-cover bg-center' style={{ backgroundImage: `url(${plantsCover})` }}>
      <Section className='mx-auto w-full flex flex-col items-center text-white py-14 lg3:py-28'>
        <div className='flex flex-col items-center lg3:w-1/2 md3:w-2/3 w-full'>
          <h3 className='text-center font-bold text-r-5xl leading-normal'>
            {t('newsletterSection.title')}
          </h3>
          <p className='text-center leading-mid text-r-2xl mt-4 lg3:mt-8'>
            {t('newsletterSection.text')}
          </p>
        </div>
        {!hasSubmitted && (
          <form
            className='w-full md3:w-2/3 lg3:w-1/2 mt-8 text-revamp-neutral-700'
            onSubmit={handleSubmit}
          >
            <div className='relative'>
              <input
                type='email'
                className={cx(
                  'w-full pl-6 pr-14 py-3 rounded-lg placeholder-revamp-neutral-500 focus:outline-none transition-all border-2',
                  isInvalid ? 'border-red-500' : 'border-transparent'
                )}
                placeholder={t('newsletterSection.placeholder')}
                value={input}
                onChange={handleInputChange}
              />
              <button
                type='button'
                className='absolute inset-y-0 right-6 flex items-center'
                onClick={handleSubmit}
              >
                <ArrowLongRightIcon className='w-6 h-6' />
              </button>
            </div>

            <p
              className={cx('text-red-500 text-sm mt-2 ml-1', isInvalid ? 'visible' : 'invisible')}
            >
              {t('newsletterSection.validationText')}
            </p>
          </form>
        )}
        {hasSubmitted && (
          <p className='text-center mt-8 text-r-xl font-bold'>
            {t('newsletterSection.successText')}
          </p>
        )}
      </Section>
    </div>
  )
}
